import { render } from "./Footer.vue?vue&type=template&id=fbd6a746&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=fbd6a746&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fbd6a746"

export default script